///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

export const filterCapacityMatches = (
  state,
  { payload: { items, field, applyOnExistingFilters, range } }
) => {
  state.capacityMatchLaneSummary.filtersApplied = false;
  if (items && field) {
    state.capacityMatchLaneSummary.columnFilters[field] = items;
    filterCapacityMatches(state, { payload: {} });
  }
  if (range && field) {
    state.capacityMatchLaneSummary.rangeFilters[field] = range;
    filterCapacityMatches(state, { payload: {} });
  }

  if (
    state.capacityMatchLaneSummary.capacityMatches &&
    state.capacityMatchLaneSummary.capacityMatches.length
  ) {
    state.capacityMatchLaneSummary.capacityMatches.forEach(matches => {
      matches.metaData.matched = true;
    });
  }

  if (!applyOnExistingFilters) {
    state.capacityMatchLaneSummary.offset = 0;
  }

  const { columnFilters, capacityMatches, rangeFilters } =
    state.capacityMatchLaneSummary;

  for (const field in columnFilters) {
    if (columnFilters[field].some(cf => cf.selected)) {
      state.capacityMatchLaneSummary.filtersApplied = true;
      capacityMatches
        .filter(matches => matches.metaData.matched)
        .forEach(matches => {
          const value = matches[field];
          if (typeof value !== "string") {
            matches.metaData.matched = columnFilters[field].some(
              cf => cf.selected && value.some(x => x === cf.value)
            );
          } else {
            matches.metaData.matched = columnFilters[field].some(
              cf => cf.selected && value === cf.value
            );
          }
        });
    }
  }

  for (const field in rangeFilters) {
    const minValue = parseFloat(rangeFilters[field].minValue);
    const maxValue = parseFloat(rangeFilters[field].maxValue);
    state.capacityMatchLaneSummary.filtersApplied = true;
    capacityMatches
      .filter(matches => matches.metaData.matched)
      .forEach(matches => {
        const value = matches[field];
        matches.metaData.matched =
          parseFloat(value) >= minValue && value <= maxValue;
      });
  }

  const filteredCapacityMatches =
    capacityMatches &&
    capacityMatches.filter &&
    capacityMatches.filter(l => l.metaData.matched);
  state.capacityMatchLaneSummary.totalFiltered = filteredCapacityMatches
    ? filteredCapacityMatches.length
    : 0;
};

export default filterCapacityMatches;
